<template>
  <v-container fluid class="dashboard" pt-0 px-0>

    <v-app-bar color="black" dark fixed app>

      <template v-if="$vuetify.breakpoint.mdAndDown">
        <hb-main-menu-button/>
      </template>

      <v-toolbar-title style="margin-left: 0;">
        <span class="title">{{ $t('ask_for_content.title') }}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

    </v-app-bar>

    <hb-loading-indicator v-if="getSalesPersonLoading || getSalesPersonLoading" align-middle/>

    <v-fade-transition hide-on-leave>

      <v-container v-if="!getSalesPersonLoading && !publicationRequestLoading">
        <v-row class="ask-for-content-holder">
          <v-col cols="8" offset="2">
            <v-fade-transition hide-on-leave>
              <v-row v-if="!salesPerson">
                <v-col cols="12" v-if="!showNoSalesPersonFound">
                  <h2>{{ $t('ask_for_content.info') }}</h2>
                </v-col>
                <v-col cols="12" v-else>
                  <v-alert :value="true" icon="mdi mdi-alert-circle" prominent text type="error">
                    <h2>{{ $t('ask_for_content.no_salesperson_found') }}</h2>

                  </v-alert>

                </v-col>
                <v-col cols="12">
                  <v-text-field :label="$t('orders.order_number')" @keyup.enter="getSalesPerson" v-model="orderId"></v-text-field>

                  <v-text-field :label="$t('ask_for_content.postal_code')" @keyup.enter="getSalesPerson" v-model="postalCode"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-btn :loading="getSalesPersonLoading" @click="getSalesPerson" :disabled="!canGetSalesPerson" color="primary">
                    {{ $t('ask_for_content.find_salesperson') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-fade-transition>
            <v-fade-transition hide-on-leave>
              <v-row v-if="salesPerson && !requestDone">
                <v-col cols="12">
                  <h2>{{ $t('ask_for_content.confirm_content_request') }}</h2>
                </v-col>
                <v-col cols="12">
                  {{ $t('ask_for_content.sales_person') }}: {{ salesPerson.name }}
                </v-col>
                <v-col cols="12">
                  {{ $t('ask_for_content.sales_person_phone') }}: {{ salesPerson.phone }}
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" class="mr-2" :loading="publicationRequestLoading" @click="askForContent">
                    {{ $t('ask_for_content.ask_for_content_button_text') }}
                  </v-btn>

                  <v-btn text @click="backButtonClick">
                    {{ $t('ask_for_content.back_button_text') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-fade-transition>
            <v-fade-transition hide-on-leave>
              <v-row v-if="requestDone">
                <v-col cols="12">
                  <h2 class="text-center">{{ $t('ask_for_content.content_request_done') }}</h2>
                </v-col>
              </v-row>
            </v-fade-transition>

          </v-col>
        </v-row>
      </v-container>
    </v-fade-transition>

  </v-container>
</template>

<script>
import PublicationRequestApi from "@/api/publicationRequestApi";

export default {
  name: 'AskForContent',
  data() {
    return {
      orderId: '',
      postalCode: '',
      requestDone: false,
      showNoSalesPersonFound: false,
      publicationRequestLoading: false,
      getSalesPersonLoading: false,
      salesPerson: null,
    }
  },
  computed: {
    canGetSalesPerson() {
      return this.orderId && this.postalCode;
    }
  },
  methods: {
    backButtonClick() {
      this.salesPerson = null;
      this.showNoSalesPersonFound = false;
    },
    async askForContent() {
      this.publicationRequestLoading = true;
      try {
        await PublicationRequestApi.createPublicationRequest(this.orderId, this.postalCode);
        this.requestDone = true;
      } catch (error) {
        this.$handleApiError(error);
      }
      this.publicationRequestLoading = false;
    },
    async getSalesPerson() {
      if (!this.canGetSalesPerson) {
        return;
      }

      this.getSalesPersonLoading = true;
      try {
        this.orderId = this.orderId.trim();
        this.postalCode = this.postalCode.trim();
        this.salesPerson = await PublicationRequestApi.getSalesPerson(this.orderId, this.postalCode);
        if (!this.salesPerson) {
          this.showNoSalesPersonFound = true;
        }
      } catch (error) {
        this.$handleApiError(error);
      }
      this.getSalesPersonLoading = false;
    }
  },
}
</script>

<style scoped>

</style>
